module.exports = __webpack_public_path__ + "6d60cee3ee8d6bee9a372599dea4a426.svg";